/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import CheckBox from '@/components/AZCustomComponent/FormGroup/CheckBox';
import styles from './styles.module.scss';
import { Divider } from '@az/starc-ui';
import { useMemo } from 'react';

type Props = {
  handleFilter: (value: number) => void;
  selectedRatings?: number[];
};

// Definindo tipos para os parâmetros da função onChange
type CheckBoxChangeEvent = React.ChangeEvent<HTMLInputElement> | React.MouseEvent<HTMLElement>;

const items = [
  {
    label: '5 stars',
    value: 5,
  },
  {
    label: '4 stars',
    value: 4,
  },
  {
    label: '3 stars',
    value: 3,
  },
  {
    label: '2 stars',
    value: 2,
  },
  {
    label: '1 star',
    value: 1,
  },
];

export const RatingFilter = ({ handleFilter, selectedRatings }: Props) => {
  const isSelected = useMemo(() => {
    return (rating: number) => selectedRatings?.includes(rating);
  }, [selectedRatings]);

  return (
    <div data-testid="rating-filter">
      <ul>
        {items.map((item) => {
          const itemLabel = item.label;

          return (
            <li key={`${itemLabel}`} className={styles.ratingItem}>
              <CheckBox
                variant="natural"
                onChange={(_event: CheckBoxChangeEvent, _checked: boolean) => {
                  handleFilter(item.value);
                }}
                label={item.label}
                id={item.value.toString()}
                checked={isSelected(item.value)}
              />
              <Divider className={styles.ratingDivider} />
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default RatingFilter;
